import React, { useState } from "react";
import ViewportTaskView from "components/ViewportContainer/Task/Task";
import SessionSettings from "components/SessionSettings/SessionSettings";

// DevExtreme components
//import { Accordion, Button } from 'devextreme-react';

// Component styles
//import classes from "./TaskView.module.scss";

export function TaskView(props) {
  const { viewports, session, dataSegment, renderViewport, noControls, closeViewport, reloadViewport } = props;
  const [showSessionSettings, setShowSessionSettings] = useState(false);

  const handleToggleShowSettings = () => {
    setShowSessionSettings(prev => !prev);
  };

  const isViewportEnabled = (index) => {
    return viewports.length - 1 === index;
  };

  const renderSessionSettings = () => {
    if (!showSessionSettings) return;
    return <SessionSettings
      title="Session Settings"
      sessionId={session.id}
      dataSegmentAuthToken={dataSegment.authToken}
      reloadViewport={reloadViewport}
      closeSettings={handleToggleShowSettings} />;
  };

  const renderViewports = () => {
    if (viewports.length === 0) return;
    return (
      viewports.map((viewport, index) => (
        <ViewportTaskView
          key={index}
          title={viewport.displayName}
          viewport={viewport}
          dataSegmentAuthToken={dataSegment.authToken}
          isEnabled={(isViewportEnabled(index))}
          isMovingAllowed={true}
          isResizeAllowed={true}
          showNoControls={noControls}
          viewportOrder={index}
          closeViewport={closeViewport}
          toggleShowSettings={handleToggleShowSettings}
          {...props}
        >
          {renderViewport(viewport, isViewportEnabled(index))}
        </ViewportTaskView>
      ))
    );
  };

  return (
    <div style={{overflow: "auto", height: "100%"}}>
      {renderViewports()}
      {renderSessionSettings()}
    </div>
  )
}